export const FETCH_TIRE_SCAN_REQUEST = 'TIRE_SCAN/FETCH_REQUEST';
export const FETCH_TIRE_SCAN_SUCCESS = 'TIRE_SCAN/FETCH_SUCCESS';
export const FETCH_TIRE_SCAN_FAILURE = 'TIRE_SCAN/FETCH_FAILURE';
